(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vespr-scent-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KLAVIYO_ID   = "XnhjHG";   /* cle publique du compte */
  var KLAVIYO_LIST = "SCBVsk";   /* liste « VESPR Newsletter », simple opt-in */
  var SC = {
    rowan:{name:"ROWAN", insp:"Tom Ford Oud Wood", notes:"oud, sandalwood, cardamom",
      handle:"rowan-body-butter", c:"#57685C",
      why:"The quiet one. Dry wood and sandalwood, never sweet — it is noticed at conversation distance, not across a room."},
    flint:{name:"FLINT", insp:"Dior Sauvage", notes:"bergamot, Sichuan pepper, dry amber",
      handle:"flint-body-butter", c:"#D0863F",
      why:"The loudest and the most versatile. Bright and peppery, it carries further than the others, so use less than you think."},
    onyx:{name:"ONYX", insp:"Louis Vuitton Ombré Nomade", notes:"saffron, oud, amber",
      handle:"onyx-body-butter", c:"#7A4B5C",
      why:"The densest of the four. Saffron and incense over oud and amber — evening, cold weather, statement moments."},
    ember:{name:"EMBER", insp:"Tom Ford Tobacco Vanille", notes:"tobacco, vanilla, tonka",
      handle:"ember-body-butter", c:"#A6402F",
      why:"Tobacco leaf wrapped in vanilla and tonka. The comfort one, and the one that lasts longest on fabric."}
  };

  /* Q3 pese le plus : ce que le nez prefere prime sur le contexte declare. */
  var W = { q1:2, q3:3 };
  var PROJ = {
    quiet:{rowan:3, ember:1},
    mid:  {ember:2, onyx:2, rowan:1},
    loud: {flint:3, onyx:1}
  };

  function score(f){
    var s={rowan:0, flint:0, onyx:0, ember:0};
    var q1=f.q1.value, q2=f.q2.value, q3=f.q3.value;
    if(s[q1]!==undefined) s[q1]+=W.q1;
    if(s[q3]!==undefined) s[q3]+=W.q3;
    var p=PROJ[q2]||{};
    for(var k in p){ if(s[k]!==undefined) s[k]+=p[k]; }
    var order=Object.keys(s).sort(function(a,b){ return s[b]-s[a]; });
    return {win:order[0], second:order[1], gap:s[order[0]]-s[order[1]]};
  }

  function card(k, tag){
    var x=SC[k];
    return '<article class="vsf-card'+(tag?' is-alt':'')+'" style="--cc:'+x.c+'">'
      + (tag?'<span class="vsf-tag">'+tag+'</span>':'')
      + '<h2>'+x.name+'</h2>'
      + '<p class="vsf-insp">Inspired by '+x.insp+'</p>'
      + '<p class="vsf-notes">'+x.notes+'</p>'
      + '<p class="vsf-why">'+x.why+'</p>'
      + '<a class="vsf-cta" href="/products/'+x.handle+'">See '+x.name+'</a>'
      + '</article>';
  }

  var form=document.getElementById("vsfQuiz");
  var out=document.getElementById("vsfResult");
  if(!form||!out) return;

  form.addEventListener("submit", function(e){
    e.preventDefault();
    if(!form.checkValidity()){ form.reportValidity(); return; }
    var r=score(form);
    var html='<p class="vsf-r-eyebrow">Your match</p>' + card(r.win);
    /* Honnetete : quand deux parfums se tiennent, on le dit au lieu de trancher au hasard. */
    if(r.gap<=1){
      html+='<p class="vsf-close">Two are close for you. '+SC[r.second].name+' is the other one worth a look, '
          + 'and the Buy 2, Get 1 Free lets you take both without choosing.</p>'
          + card(r.second, "Runner-up");
    }
    html+= '<form class="vsf-mail" id="vsfMail" novalidate>'
      +   '<p class="vsf-mail__h">Want it in writing?</p>'
      +   '<p class="vsf-mail__p">We will email you your match, how much to use so it holds the full eight hours, '
      +       'and the two scents to try next. No daily mail, and one click to stop.</p>'
      +   '<div class="vsf-mail__row">'
      +     '<label class="vsf-mail__lab" for="vsfMailInput">Email address</label>'
      +     '<input type="email" id="vsfMailInput" name="email" required autocomplete="email" '
      +            'inputmode="email" placeholder="you@example.com">'
      +     '<button type="submit">Send it</button>'
      +   '</div>'
      +   '<p class="vsf-mail__note" id="vsfMailNote" role="status" aria-live="polite"></p>'
      + '</form>';
    html+='<button type="button" class="vsf-again" id="vsfAgain">Start over</button>';
    out.innerHTML=html;
    out.hidden=false;
    out.scrollIntoView({behavior:"smooth", block:"start"});
    /* capture e-mail : abonnement client a la liste VESPR Newsletter,
       avec le parfum trouve en propriete pour personnaliser la suite. */
    var mail=document.getElementById("vsfMail");
    if(mail) mail.addEventListener("submit", function(ev){
      ev.preventDefault();
      var input=document.getElementById("vsfMailInput");
      var note=document.getElementById("vsfMailNote");
      var btn=mail.querySelector("button[type=submit]");
      if(!input.value || !input.checkValidity()){ note.textContent="Enter a valid email address."; note.className="vsf-mail__note is-err"; input.focus(); return; }
      btn.disabled=true; note.className="vsf-mail__note"; note.textContent="Sending…";
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KLAVIYO_ID, {
        method:"POST",
        headers:{"revision":"2024-10-15","content-type":"application/json"},
        body: JSON.stringify({data:{type:"subscription",attributes:{
          custom_source:"Scent finder quiz",
          profile:{data:{type:"profile",attributes:{
            email: input.value,
            properties:{"Quiz scent":SC[r.win].name,"Quiz runner up":SC[r.second].name,"Quiz source":"find-your-scent"}
          }}}
        },relationships:{list:{data:{type:"list",id:KLAVIYO_LIST}}}}})
      }).then(function(res){
        if(res.ok || res.status===202){
          mail.innerHTML='<p class="vsf-mail__h">Sent.</p><p class="vsf-mail__p">Check your inbox — and your promotions tab, it sometimes lands there.</p>';
          if(window.klaviyo) try{ window.klaviyo.identify({$email:input.value}); }catch(e){}
        } else {
          note.textContent="That did not go through. Email hello@vesprskin.com and we will send it manually.";
          note.className="vsf-mail__note is-err"; btn.disabled=false;
        }
      }).catch(function(){
        note.textContent="That did not go through. Email hello@vesprskin.com and we will send it manually.";
        note.className="vsf-mail__note is-err"; btn.disabled=false;
      });
    });

    var again=document.getElementById("vsfAgain");
    if(again) again.addEventListener("click", function(){
      form.reset(); out.hidden=true; out.innerHTML="";
      form.scrollIntoView({behavior:"smooth", block:"start"});
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
